import { inject, provide, ref } from 'vue'

export const NAV_EXPANDED_KEY = 'nr-nav-expanded'
const navRailExpanded = Symbol('navRailExpanded')

export function provideNavRail() {
  const expanded = ref(false)

  try {
    expanded.value = localStorage.getItem(NAV_EXPANDED_KEY) === '1'
  } catch {
    // Storage can be unavailable; the collapsed rail remains usable.
  }

  function toggleNavRail() {
    expanded.value = !expanded.value
    try {
      localStorage.setItem(NAV_EXPANDED_KEY, expanded.value ? '1' : '0')
    } catch {
      // Persistence is optional.
    }
  }

  provide(navRailExpanded, expanded)
  return { expanded, toggleNavRail }
}

export function useNavRailExpanded() {
  return inject(navRailExpanded, ref(false))
}
